//////////////////////////////////////////////////////////////
//                                                          //
// Keep it in sync with GalleriesHelper#get_default_modulus //
//                                                          //
//////////////////////////////////////////////////////////////

import { sample, without } from 'lodash-es'

const samples = [11, 13, 17, 19, 23, 29, 31, 37, 41, 43, 47, 53, 59, 61, 67, 71, 73, 79, 83, 89, 97]

export default function generateModulus(last) {
  return last = sample(without(samples, last))
}
